// Centralized pricing logic.
// Adjust DISCOUNT_RATE to change the sitewide discount.
export const DISCOUNT_RATE = 0.10; // 10% off
export const DISCOUNT_LABEL = "10% OFF";

// Products excluded from the sitewide discount (e.g., donation items).
export function isDiscountExcluded(product) {
  const name = (product?.name || "").toLowerCase();
  const collection = (product?.collection || "").toLowerCase();
  return name.includes("adore") || collection === "adore";
}

// Returns the price the customer actually pays (as a string with 2 decimals).
export function getDisplayPrice(product) {
  if (!product) return "0.00";
  if (isDiscountExcluded(product)) return product.price.toFixed(2);
  return (product.price * (1 - DISCOUNT_RATE)).toFixed(2);
}

// Returns the original (strikethrough) price or null if not applicable.
export function getOriginalPrice(product) {
  if (!product || isDiscountExcluded(product)) return null;
  return product.price.toFixed(2);
}
